import * as yup from 'yup'

const schema = ({ reject = false }) =>
  yup.object().shape({
    rejectionReason: yup.string().when([], {
      is: () => reject,
      then: (schema) => schema.required(),
    }),
    approvalComment: yup.string(),
  })

export default schema
